module.exports = __webpack_public_path__ + "static/img/guide-loading.10281c7.gif";